import NextImage from "next/image";
import { ChakraProps, chakra } from "@chakra-ui/react";

interface Props extends ChakraProps {
  src: string | StaticImageData;
  alt: string;
  width?: number | string;
  height?: number | string;
  layout?: "fixed" | "fill" | "intrinsic" | "responsive";
}

const Image = (props: Props) => {
  const { layout, width, height, alt, src, ...chakraProps } = props;
  const nextProps = {
    ...(layout ? { layout } : {}),
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
    alt,
  };

  const CustomizedNextImage = () => (
    <NextImage src={src} {...nextProps} unoptimized />
  );
  const ChakraImage = chakra(CustomizedNextImage);

  return <ChakraImage {...chakraProps} />;
};

export default Image;
